export default __webpack_public_path__ + "static/lp-evergreen-mobile-604ac4325ed8539d6234c205aee48533.webp";